import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { sizes } from "../../../constants/spacing";
import { MenuLayoutOptions } from "../types/Menu";
import { MenuPlacement } from "../types/MenuPlacement";
import { getMenuAnimation } from "./getMenuAnimation";
import { menuTheme } from "./menuTheme";

export interface MenuContainerStyledProps {
    applyMinWidth: boolean;
    layout: MenuLayoutOptions;
    placement: MenuPlacement;
    themeKey: RequiredThemeKeys;
}

export const MenuContainerStyled = styled("div")<MenuContainerStyledProps>`
    border-radius: ${({ themeKey, layout }) =>
        `var(--sds--menu--border-radius--${layout}, ${menuTheme.borderRadius(themeKey)})`};
    box-shadow: ${({ themeKey }) => menuTheme.boxShadow(themeKey)};
    background-color: ${({ themeKey }) => menuTheme.backgroundColor.rest(themeKey)};
    flex-direction: column;
    gap: ${({ layout }) => (layout === "dense" ? sizes.xxSmall : 0)}px;
    white-space: nowrap;
    display: flex;
    min-width: var(--sds--menu--min-width, ${({ applyMinWidth }) => (applyMinWidth ? "240px" : "auto")});

    // To allow the container's height to be set manually and add a scrollable area.
    overflow-y: auto;

    // To ensure menus show up on top of menu items they might be rendered within.
    z-index: 1;

    // No right/left padding here. The menu items themselves should add the
    // left/right margin so they have the greatest flexibility.
    padding: ${({ layout }) => `var(--sds--menu--padding--${layout}, ${sizes.xSmall}px 0)`};

    // This removes a bit of a janky outline on the menu itself.
    // The first element in the Menu will automatically be focused so the menu doesn't get focus.
    outline: none;

    opacity: 0;

    // The menu doesn't exist until the target is clicked, which is why this works
    // This could be refactored to target via classname
    &[role="menu"] {
        opacity: 1;
        transition: opacity ${({ themeKey }) => menuTheme.motion.animation(themeKey)};
        animation: ${({ placement }) => getMenuAnimation(placement)}
            ${({ themeKey }) => menuTheme.motion.animation(themeKey)};
    }
`;
